import { call, put, takeLatest, delay, select } from 'redux-saga/effects';
import { APP } from 'src/store/ActionTypes';
import { switchClient } from 'src/functions';

import * as api from 'src/store/api';

function* register(action) {
  try {
    yield call(api.register, action.payload);
    yield put({
      type: APP.REGISTER_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: APP.REGISTER_FAILED,
      payload: e,
    });
  } finally {
    delay(500);
    yield put({
      type: APP.UNSET,
      payload: 'registerStatus',
    });
  }
}

function* fetchProfile() {
  try {
    const profile = yield call(api.fetchProfile);
    yield put({
      type: APP.FETCH_PROFILE_SUCCEEDED,
      payload: profile,
    });
    const {
      app: { client: currentClient, tenant },
    } = yield select();
    // If we don't have a active tenant
    // set it from the profile
    if (!tenant || !currentClient) {
      const client = yield call(api.fetchClientByTenant, profile.tenant);
      yield put({
        type: APP.SET_CLIENT,
        payload: client,
      });
      yield put({
        type: APP.SET_TENANT,
        payload: profile.tenant,
      });
    }
  } catch (e) {
    yield put({
      type: APP.FETCH_PROFILE_FAILED,
      payload: e,
    });
  }
}

function* fetchClients() {
  try {
    const clients = yield call(api.getClients);
    yield put({
      type: APP.FETCH_CLIENTS_SUCCEEDED,
      payload: clients,
    });
  } catch (e) {
    yield put({
      type: APP.FETCH_CLIENTS_FAILED,
      payload: e,
    });
  }
}

function* getPresignedUrl(action) {
  try {
    const { bucket, key } = action.payload;
    const url = yield call(api.getFileDownloadUrl, bucket, key);
    yield put({
      type: APP.GET_PRESIGNED_URL_SUCCEEDED,
      payload: url,
    });
  } catch (e) {
    yield put({
      type: APP.GET_PRESIGNED_URL_FAILED,
      payload: e,
    });
  }
}

function* getFileViaSignedUrl(action) {
  try {
    const { bucket, key } = action.payload;
    const url = yield call(api.getFileDownloadUrl, bucket, key);
    window.open(url, '_blank');
  } catch (e) {
    yield put({
      type: APP.GET_PRESIGNED_URL_FAILED,
      payload: e,
    });
  }
}

function* fetchDatasets(action) {
  try {
    const { payload: query } = action;
    const datasets = yield call(api.fetchDatasets, query);
    yield put({
      type: APP.FETCH_DATASETS_SUCCEEDED,
      payload: datasets,
    });
  } catch (e) {
    yield put({
      type: APP.FETCH_DATASETS_FAILED,
      payload: e,
    });
  }
}

function* addClient(action) {
  try {
    yield call(api.addClient, action.payload);
    yield put({
      type: APP.ADD_CLIENT_SUCCEEDED,
    });
    yield* fetchClients();
  } catch (e) {
    yield put({
      type: APP.ADD_CLIENT_FAILED,
      payload: e,
    });
  } finally {
    delay(500);
    yield put({
      type: APP.UNSET,
      payload: 'addClientStatus',
    });
  }
}

function* delClient(action) {
  try {
    yield call(api.delClient, action.payload);
    yield put({
      type: APP.DEL_CLIENT_SUCCEEDED,
    });
    yield* fetchClients();
  } catch (e) {
    yield put({
      type: APP.DEL_CLIENT_FAILED,
      payload: e,
    });
  } finally {
    delay(500);
    yield put({
      type: APP.UNSET,
      payload: 'delClientStatus',
    });
  }
}

function* selectClient(action) {
  const {
    payload: client,
    payload: { tenant },
  } = action;
  try {
    yield call(switchClient, tenant);
    yield put({
      type: APP.SELECT_CLIENT_SUCCEEDED,
    });
    yield put({
      type: APP.SET_TENANT,
      payload: tenant,
    });
    yield put({
      type: APP.SET_CLIENT,
      payload: client,
    });
    yield call(fetchProfile);
  } catch (e) {
    yield put({
      type: APP.SELECT_CLIENT_FAILED,
    });
  } finally {
    delay(500);
    yield put({
      type: APP.UNSET,
      payload: 'selectClientStatus',
    });
  }
}

function* submitFeedback(action) {
  const {
    payload: { page, feedback },
  } = action;
  try {
    yield call(api.submitFeedback, { page, feedback });
    yield put({
      type: APP.SUBMIT_FEEDBACK_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: APP.SUBMIT_FEEDBACK_FAILED,
    });
  } finally {
    delay(500);
    yield put({
      type: APP.UNSET,
      payload: 'submitFeedbackStatus',
    });
  }
}

function* addClientSaga() {
  yield takeLatest(APP.ADD_CLIENT, addClient);
}

function* delClientSaga() {
  yield takeLatest(APP.DEL_CLIENT, delClient);
}

function* registerSaga() {
  yield takeLatest(APP.REGISTER, register);
}

function* fetchProfileSaga() {
  yield takeLatest(APP.FETCH_PROFILE, fetchProfile);
}

function* fetchClientsSaga() {
  yield takeLatest(APP.FETCH_CLIENTS, fetchClients);
}

function* selectClientSaga() {
  yield takeLatest(APP.SELECT_CLIENT, selectClient);
}

function* fetchDatasetsSaga() {
  yield takeLatest(APP.FETCH_DATASETS, fetchDatasets);
}

function* submitFeedbackSaga() {
  yield takeLatest(APP.SUBMIT_FEEDBACK, submitFeedback);
}

function* getPresignedUrlSaga() {
  yield takeLatest(APP.GET_PRESIGNED_URL, getPresignedUrl);
}

function* getFileViaSignedUrlSaga() {
  yield takeLatest(APP.GET_URL_FOR_DL, getFileViaSignedUrl);
}

export default [
  addClientSaga(),
  delClientSaga(),
  registerSaga(),
  fetchProfileSaga(),
  fetchClientsSaga(),
  selectClientSaga(),
  fetchDatasetsSaga(),
  submitFeedbackSaga(),
  getPresignedUrlSaga(),
  getFileViaSignedUrlSaga(),
];
